import { useAdyenPayload } from '@/checkout/hooks/use-adyen-payload';
import Payment, { PaymentProps } from '@/checkout/components/payment';
import PaymentHiddenInputs from '@/checkout/components/payment-hidden-inputs';
import Spacer from '@/common/components/spacer';
import StatusBanner from '@/common/components/status-banner';
import { PaymentTitle, PaymentType } from '@/account/types/payment-method-configuration';
import * as gtag from '@/common/utils/gtags.client';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
export interface PaymentFormFragmentProps
  extends Omit<PaymentProps, 'onPaymentChange' | 'paymentType' | 'paymentTitle'> {
  paymentError?: string;
}

export default function PaymentFormFragment({
  adyenOriginKey,
  adyenJsSrc,
  paymentMethodConfiguration,
  showCancellationBlurb,
  shouldAllowStoredPaymentMethods,
  paymentError,
}: PaymentFormFragmentProps) {
  const { paymentMethod, onPaymentChange } = useAdyenPayload();
  const [sentEvent, setSentEvent] = useState(false);

  const storedCardPaymentMethods = paymentMethodConfiguration?.storedPaymentMethods;
  const storedCardPayment =
    storedCardPaymentMethods && storedCardPaymentMethods?.length > 0
      ? storedCardPaymentMethods[0]
      : null;
  const { pathname } = useLocation();

  useEffect(() => {
    const isACheckoutPage = pathname.includes('review') || pathname.includes('swap');
    if (!sentEvent && paymentMethod && isACheckoutPage) {
      gtag.event('complete_payment_method');
      setSentEvent(true);
    }
  }, [paymentMethod, sentEvent, pathname]);

  return (
    <>
      <Payment
        onPaymentChange={onPaymentChange}
        showCancellationBlurb={showCancellationBlurb}
        adyenOriginKey={adyenOriginKey}
        adyenJsSrc={adyenJsSrc}
        paymentMethodConfiguration={paymentMethodConfiguration}
        shouldAllowStoredPaymentMethods={shouldAllowStoredPaymentMethods}
        paymentType={PaymentType.card}
        paymentTitle={PaymentTitle.card}
        storedCardPaymentMethod={storedCardPayment}
      />

      {paymentError ? (
        <>
          <Spacer variant="height24" />
          <StatusBanner
            variant="error"
            message={{
              text: paymentError,
            }}
          />
        </>
      ) : null}

      <PaymentHiddenInputs
        paymentMethod={paymentMethod}
        storedPaymentMethods={paymentMethodConfiguration?.storedPaymentMethods}
        shouldAllowStoredPaymentMethods={shouldAllowStoredPaymentMethods}
      />
    </>
  );
}
